import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import orderby from "lodash.orderby"; //Limitless imports

import ClientContext from "../../../common/utils/client-context/ClientContext";
import { log as logger } from "../../../common/utils/Logging";
import { uniqueArrayBy } from "../../../common/utils/array-helper/ArrayHelper";
import { useNotificationContext } from "../../../common/hooks";
import { fetchCustomerHistory } from "../../apis/customer-message-history-api/CustomerMessageHistoryAPI";
import { useCustomerContext } from "../customer/CustomerContext";
var INITIAL_STATE = {
  activeMessages: [],
  previousMessages: [],
  loading: false
};

var isMessageActive = function isMessageActive(message) {
  if (message.custResolved) {
    return false;
  }

  if (message.accepted && message.acceptedDate && message.customerScore && message.custTestimonial) {
    return false;
  }

  if (message.state === "closed") {
    return false;
  }

  return true;
};

export var useCustomerHistory = function useCustomerHistory() {
  var _React$useState = React.useState(INITIAL_STATE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      history = _React$useState2[0],
      setHistory = _React$useState2[1];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      sessionMessages = _React$useState4[0],
      setSessionMessages = _React$useState4[1];

  var _useCustomerContext = useCustomerContext(),
      customer = _useCustomerContext.customer;

  var _useNotificationConte = useNotificationContext(),
      addFailureNotification = _useNotificationConte.addFailureNotification;

  var log = logger.getLogger("useCustomerHistory");
  React.useEffect(function () {
    //only load history if we have the email address hash & customer key
    if (customer.customerEmailHash && ClientContext._customerKey) {
      loadHistory();
    }
  }, [customer.customerEmailHash]);
  React.useEffect(function () {
    if (!history.loading) {
      processHistoryMessages([].concat(_toConsumableArray(sessionMessages), _toConsumableArray(history.activeMessages), _toConsumableArray(history.previousMessages)));
    }
  }, [sessionMessages, history.loading]);

  var loadHistory = function loadHistory() {
    setHistory(_objectSpread({}, history, {
      loading: true
    }));
    fetchCustomerHistory(customer.customerEmailHash, function (result) {
      if (!result.hasError) {
        log.debug("".concat(sessionMessages.length, " session message"));
        log.debug("".concat(result.length, " from history api"));
        var historyMessages = result.concat(sessionMessages);
        processHistoryMessages(historyMessages);
      } else {
        addFailureNotification("Unable to retrieve history");
        setHistory(_objectSpread({}, history, {
          loading: false
        }));
      }
    });
  };

  var addMessageToHistory = function addMessageToHistory(message) {
    var newSessionMessages = [].concat(_toConsumableArray(sessionMessages), [message]);
    setSessionMessages(newSessionMessages);
  };

  var updateHistoryMessage = function updateHistoryMessage(message) {
    var allMessages = [].concat(_toConsumableArray(sessionMessages), _toConsumableArray(history.activeMessages), _toConsumableArray(history.previousMessages));
    var index = allMessages.findIndex(function (m) {
      return m.messageId === message.messageId;
    });
    allMessages.splice(index, 1, message);
    processHistoryMessages(allMessages);
  };
  /**
   * pretty inefficient, but will do for now
   *
   * @param {array} historyMessages
   */


  var processHistoryMessages = function processHistoryMessages(historyMessages) {
    var uniquiehistoryMessages = uniqueArrayBy(historyMessages, "messageId");
    log.debug("".concat(uniquiehistoryMessages.length, " history messages"), uniquiehistoryMessages);
    var activeMessages = [];
    var previousMessages = [];
    uniquiehistoryMessages.map(function (message) {
      if (isMessageActive(message)) {
        activeMessages.push(message);
      } else {
        previousMessages.push(message);
      }
    });
    setHistory(_objectSpread({}, history, {
      loading: false,
      activeMessages: orderby(activeMessages, ["messageStatus", function (message) {
        var lastDialogue = message.dialogues[message.dialogues.length - 1];
        return lastDialogue.updated;
      }], ["desc", "desc"]),
      previousMessages: orderby(previousMessages, ["created"], ["desc"])
    }));
  };

  return {
    history: history,
    addMessageToHistory: addMessageToHistory,
    updateHistoryMessage: updateHistoryMessage
  };
};